import React from "react";
import TechButton from "./TechButton";
import { motion } from "framer-motion";

const SkillsCard = ({ data }) => {
  return (
    <motion.div
      className="SkillsCard"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}>
      <div className="skillsHeader">{data.name}</div>
      <div className="skillsContent">
        {data.collection.map((item, index) => (
          <TechButton data={item} key={index} />
        ))}
      </div>
    </motion.div>
  );
};

export default SkillsCard;
